import {isAfter, isBefore} from 'date-fns';

export const clampDateToRange = (date: Date, minDate: Date, maxDate: Date): Date => {
    if (isBefore(date, minDate)) {
        return minDate;
    }

    if (isAfter(date, maxDate)) {
        return maxDate;
    }

    return date;
};
